var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#37364D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_2388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 11.6573C20.5588 11.8477 20.0786 11.9847 19.5839 12.038C20.0945 11.7337 20.4824 11.2535 20.6655 10.6824C20.194 10.9636 19.6604 11.1699 19.1052 11.2766C18.6552 10.7963 18.0163 10.4993 17.3083 10.4993C15.9454 10.4993 14.8494 11.6039 14.8494 12.9595C14.8494 13.1499 14.8725 13.3403 14.91 13.5234C12.8694 13.4167 11.0494 12.4418 9.83944 10.9492C9.62601 11.3155 9.50487 11.7337 9.50487 12.1909C9.50487 13.0446 9.93895 13.7974 10.6009 14.2402C10.1971 14.2243 9.81637 14.1104 9.48901 13.9272V13.9575C9.48901 15.153 10.3341 16.1438 11.4604 16.3716C11.2542 16.425 11.0335 16.4553 10.8129 16.4553C10.6528 16.4553 10.5014 16.4394 10.3485 16.4178C10.66 17.3927 11.5671 18.1008 12.6473 18.1238C11.8022 18.7858 10.7437 19.1751 9.59428 19.1751C9.38806 19.1751 9.19769 19.1679 9.00012 19.1449C10.0904 19.8443 11.384 20.2481 12.7771 20.2481C17.2996 20.2481 19.7743 16.5014 19.7743 13.2494C19.7743 13.1427 19.7743 13.036 19.7671 12.9293C20.2459 12.5788 20.6655 12.1447 21.0001 11.6573Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_2388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(9.00012 8.99963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTt);
export default __webpack_public_path__ + "static/media/icon_tt.e475c2f1ce06d62a35801fc38a580556.svg";
export { ForwardRef as ReactComponent };